import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useIsRemixAvailable } from './useIsRemixAvailable.ts';

/**
 * Returns whether right-side remix entrypoints are available for the current user/site.
 *
 * Extends useIsRemixAvailable with an additional feature gate check:
 * - confluence_remix_button_right_side_block_fg must be enabled
 *
 * Use this hook for right-side remix entrypoints (inline nudge icons, block
 * decorations, drag handles, etc.)
 */
export const useIsRemixRightSideEnabled = (): boolean => {
	const isRemixAvailable = useIsRemixAvailable();
	return fg('confluence_remix_button_right_side_block_fg') && isRemixAvailable;
};
